import { render, staticRenderFns } from "./DocumentViewerPDFJS.vue?vue&type=template&id=562ca796&scoped=true"
import script from "./DocumentViewerPDFJS.vue?vue&type=script&lang=js"
export * from "./DocumentViewerPDFJS.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewerPDFJS.vue?vue&type=style&index=0&id=562ca796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ca796",
  null
  
)

export default component.exports